const eventCardSlider = new Swiper('.event-card-list__swiper', {
  loop: false,
  slidesPerView: 1.5,
  spaceBetween: 10,
  breakpoints: {
    768: {
      slidesPerView: 3.1,
    },
    1024: {
      slidesPerView: 4,
    },
    1350: {
      slidesPerView: 4,
      spaceBetween: 30,
    },
  },

  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});
